var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[(_vm.items.length == 0)?_c('div',{staticClass:"pa-3"},[_c('p',[_vm._v("Sin imágenes")])]):_c('vue-picture-swipe',{attrs:{"items":_vm.items,"options":_vm.photoSwipeOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }